export default "__VITE_ASSET__BROcxjoh__"